import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=21c8b18b&scoped=true"
import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=21c8b18b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8b18b",
  null
  
)

export default component.exports